import React from 'react';
import { useState } from 'react';

const CustomButton = ({ beforeHover, afterHover, isSimulating, isSmall, display, children, ...attributes }) => {

    const [isHover, setIsHover] = useState(false);

    const handleMouseEnter = () => {
        setIsHover(true);
    };
    const handleMouseLeave = () => {
        setIsHover(false);
    };

    const btnStyle = {
        fontSize: 17, 
        backgroundColor: isSimulating ? "#ababab" : isHover ? afterHover : beforeHover , 
        color: "white", 
        padding: isSmall ? "5px 16px"  : "8px 20px", 
        border: "none", 
        borderRadius: "5px", 
        cursor: isSimulating? "default" : "pointer",
        display: display
    };

    return (
        <button
            type="button"
            className="custombtn"
            style={btnStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            {...attributes}
        >
            {children}
        </button>
    );
}

CustomButton.defaultProps = {
    beforeHover: "#387ADF",
    afterHover: "#0B60B0",
    isSimulating: false,
    isSmall: false,
    display: "inline"
}

export default CustomButton